import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useState,
} from "react";

const context = createContext<{
  price: bigint;
  setPrice: (v: bigint) => void;
  premium: bigint;
  setPremium: (v: bigint) => void;
  amount: bigint;
  setAmount: (v: bigint) => void;
  address?: string;
  base?: string;
  quote?: string;
}>({
  price: 0n,
  setPrice: () => {},
  premium: 0n,
  setPremium: () => {},
  amount: 0n,
  setAmount: () => {},
  address: undefined,
  base: undefined,
  quote: undefined,
});

export const TradeContext: FC<
  PropsWithChildren<{
    address?: string;
    base?: string;
    quote?: string;
  }>
> = ({ children, address, base, quote }) => {
  const [price, setPrice] = useState(0n);
  const [premium, setPremium] = useState(0n);
  const [amount, setAmount] = useState(0n);

  return (
    <context.Provider
      value={{
        price,
        setPrice,
        premium,
        setPremium,
        amount,
        setAmount,
        address,
        base,
        quote,
      }}>
      {children}
    </context.Provider>
  );
};

export const usePrice = (): [bigint, (v: bigint) => void] => {
  const { price, setPrice } = useContext(context);
  return [price, setPrice];
};

export const usePremium = (): [bigint, (v: bigint) => void] => {
  const { premium, setPremium } = useContext(context);
  return [premium, setPremium];
};

export const useAmount = (): [bigint, (v: bigint) => void] => {
  const { amount, setAmount } = useContext(context);
  return [amount, setAmount];
};

export const useTradeContext = (): {
  base?: string;
  quote?: string;
  address?: string;
} => {
  const { base, quote, address } = useContext(context);
  return { base, quote, address };
};

export const adjust = (price: bigint, tick: number): bigint => {
  if (!price) return 0n;
  const truncLen = price.toString().length - tick;
  const trunc = 10n ** BigInt(truncLen);
  return BigInt((price / trunc) * trunc);
};
